let routes = [
    {
      path: '/demande-enquete',
      component: () => import('../views/DemandeEnquete.vue'),
      props: true
    },
    {
      path: '/demande-enquete/:step',
      component: () => import('../views/DemandeEnquete.vue'),
      props: true
    }
  ]
  
  export default routes;